define('views/modals/goods-card/content',['require','jquery','underscore','chaplin','mediator','lib/utils','views/base/view','text!templates/modals/goods-card/content.ejs','text!templates/modals/goods-card/values.ejs','models/modals/organization/index','views/modals/organization/index','views/dialog','views/demo-dialog'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        Chaplin = require('chaplin'),
        mediator = require('mediator'),
        utils = require('lib/utils'),
        View = require('views/base/view'),
        template = require('text!templates/modals/goods-card/content.ejs'),
        templateValues = require('text!templates/modals/goods-card/values.ejs'),
        OrganizationModalModel = require('models/modals/organization/index'),
        OrganizationModalView = require('views/modals/organization/index'),
        Dialog = require('views/dialog'),
        DemoDialog = require('views/demo-dialog');

    function Repeater(delay, interval) {
        this.delay = delay;
        this.interval = interval;
    }

    Repeater.prototype.start = function(fn) {
        var that = this;

        function iterate() {
            that._interval = setInterval(function() {
                fn();
            }, that.interval);
        }

        this.stop();
        fn();
        this._timeout = setTimeout(iterate, this.delay);
    };

    Repeater.prototype.stop = function() {
        if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }

        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    };


    var GoodsCardModalValuesView = View.extend({
        autoRender: true,
        tagName: 'table',
        className: 'table',
        region: 'goods-card-values',
        template: templateValues,
        events: {
            'click #btn-flash-order': 'clickFlashOrder',
            'click #btn-add-to-basket': 'clickAddToBasket',
            'click #btn-add-remove-favorites': 'clickAddRemoveFavorites'
        },
        listen: {
            'afterLoad model': 'render',
            'change:basketAmount model': 'render',
            'addFavoriteGoods mediator': 'onAddFavoriteGoods',
            'removeFavoriteGoods mediator': 'onRemoveFavoriteGoods',
            'change:favoriteId model': 'render'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
            if (this.model.get('canBuy')) {
                this.repeater = new Repeater(500, 100);

                this.delegate('mousedown', '#btn-card-add', this.addClick);
                this.delegate('mousedown', '#btn-card-del', this.delClick);

                this.delegate('mouseup', '#btn-card-add', this.clickOff);
                this.delegate('mouseup', '#btn-card-del', this.clickOff);

                this.delegate('mouseleave', '#btn-card-add', this.clickOff);
                this.delegate('mouseleave', '#btn-card-del', this.clickOff);
            }
            this.delegate('click', '#btn-card-clear', this.clearClick);
        },
        render: function() {
            View.prototype.render.apply(this, arguments);
        },
        dispose: function() {
            if (this.disposed) { return; }

            if (this.repeater) {
                this.repeater.stop();
            }

            View.prototype.dispose.apply(this, arguments);
        },
        addClick: function() {
            var model = this.model;

            this.repeater.start(function() {
                model.set('basketComment', $('#goods-card-comment').val());
                model.set('basketAmount', model.get('basketAmount') + model.get('minLot'));
            });
        },
        delClick: function() {
            var model = this.model;
            var repeater = this.repeater;

            repeater.start(function() {
                var value = Math.max(model.get('basketAmount') - model.get('minLot'), 0);
                model.set('basketComment', $('#goods-card-comment').val());
                model.set('basketAmount', value);

                if (value === 0) {
                    repeater.stop();
                }
            });
        },
        clickOff: function() {
            this.repeater.stop();
        },
        clearClick: function() {
            this.model.set('basketComment', $('#goods-card-comment').val());
            this.model.set('basketAmount', 0);
        },
        clickFlashOrder: function(){
            var _this = this;

            if (DemoDialog.isDemo()) { return DemoDialog.show(); }

            var tradeName = this.model.get('tradeCode');

            var requestData = {
                tradeId: this.model.get('tradeId'),
                tradeGoodsId: this.model.get('tradeGoodsId'),
                organizationOfferId: this.model.get('organizationOfferId'),
                basketAmount: this.model.get('basketAmount'),
                basketMinLot: this.model.get('minLot'),
                basketComment: $('#goods-card-comment').val(),

                basketPrice: this.model.get('traderBasePrice'),
                basketKoefPercent: this.model.get('koefPercent'),
                basketKoefVolume: this.model.get('koefVolume'),
                basketKoefWeight: this.model.get('koefWeight'),
                basketIdMainChain: this.model.get('idMainChain'),
                basketIdAddChain: this.model.get('idAddChain'),
            };

            var rn = function(obj, fieldName){
                if(!obj[fieldName]){
                    delete obj[fieldName];
                }
            };

            rn(requestData, 'tradeGoodsId');
            rn(requestData, 'basketIdMainChain');
            rn(requestData, 'basketIdAddChain');

            if(requestData.basketAmount === 0){ return; }

            this.model.trigger('leaveHide', true);

            Dialog
                .show('Мгновенный заказ', 'Удаление заказа после отправки невозможно! Вы действительно хотите отправить заказ?', Dialog.Buttons.YesNo)
                .attach(this)
                .submit(function() {

                    utils.post('/api/request/flash-order', {}, requestData).complete(function(xhr) {
                        var result = xhr.responseJSON || {};
                        var resultMap = {
                            'limit': 'Для оформления мгновенного заказа необходимо уменьшить кол-во товара до ' + result.value + '.',
                            'moneyLimit': 'Для оформления заказа находящегося в вашей корзине недостаточно денежных средств. По вопросу получения кредита, обратитесь к вашему персональному менеджеру.',
                            'closed': 'Торговая сессия по Т.П. ' + tradeName + ' закрыта, по вопросам оформления заказа обратитесь к своему персональному менеджеру.',
                            'error': 'Неизвестная ошибка.'
                        };
                        if (result.status === 'success') {
                            Dialog
                                .show('Мгновенный заказ', 'Ваш заказ по Т.П. ' + tradeName + ' сохранен в системе и отправлен на рассмотрение к поставщику. Отследить состояние заказа возможно в разделе "Заказы". Если потребуется, поставщик свяжется с вами по указанным контактным данным.', Dialog.Buttons.Close)
                                .attach(_this)
                                .cancel(function(){
                                    setTimeout(function(){
                                        _this.model.trigger('close');
                                    }, 0);
                                });

                            _this.model.trigger('updateBasketByFlashOrder');
                        } else {
                            Dialog
                                .show('Не удалось выполнить мгновенный заказ.', resultMap[result.status || 'error'] || resultMap.error, Dialog.Buttons.Close)
                                .attach(_this)
                                .cancel(function(){
                                    _this.model.trigger('leaveHide', false);
                                });
                        }
                    });
                })
                .cancel(function(){
                    _this.model.trigger('leaveHide', false);
                });

        },

        clickAddToBasket: function(){
            this.model.trigger('addToBasket');
        },
        clickAddRemoveFavorites: function(){
            var model = this.model;
            var favoriteId = model.get('favoriteId');

            if (favoriteId) {
                Chaplin.mediator.execute('removeFavoriteGoods', favoriteId);
            } else {
                Chaplin.mediator.execute('addFavoriteGoods', model.get('goodsId'));
            }
        },
        onAddFavoriteGoods: function(item) {
            this.model.set('favoriteId', item.id);
        },
        onRemoveFavoriteGoods: function() {
            this.model.set('favoriteId', null);
        }
    });


    var GoodsCardModalContentView = View.extend({
        autoRender: true,
        className: 'goods-card-modal-content',
        region: 'modal-content',
        template: template,
        events: {
            'click #open-seller-card-link': 'clickOrganizationCard'
        },
        regions: {
            'goods-card-values': '.goods-card-values'
        },
        listen: {
            'afterLoad model': 'render'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);

            console.log('start load');
            this.model.load();

        },
        render: function() {
            View.prototype.render.apply(this, arguments);
            this.subview('goods-card-values', new GoodsCardModalValuesView({model: this.model}));
        },
        clickOrganizationCard: function(){
            var modalModel = new OrganizationModalModel({
                id: this.model.get('sellerId'),
                dontRemoveHtmlClass: true
            });
            var modal = new OrganizationModalView({model: modalModel});
        }
    });

    return GoodsCardModalContentView;
});

